import {useMemo} from 'react'
import { useTenantConfig } from '@app/hooks/useTenantConfig'

interface AutoVerifyTipstersConfig {
  loading: boolean
  enabled: boolean
  publicChannelId: number | null
}

/**
 * Returns whether the current tenant has tipster auto-verification enabled
 * and which channel new tipsters should be subscribed to.
 *
 * Driven by the `auto_verify_tipsters` feature flag stored in the
 * `feature_flags` table with metadata: { publicChannelId: <number> }.
 *
 * When enabled, the /tipster/showtime screen is bypassed entirely —
 * the tipster is auto-onboarded and redirected to the feed.
 */
export function useAutoVerifyTipsters(): AutoVerifyTipstersConfig {
  const { getTenantValue, tenantConfigLoading: loading } = useTenantConfig()
  const flag = getTenantValue('featureFlags.auto_verify_tipsters', {})
  return {
    loading,
    enabled: flag?.enabled ?? false,
    publicChannelId: (flag?.metadata?.publicChannelId as number) ?? null,
  }
}
